import styled from "styled-components";
import { STPaper } from "@src/Components/Ui/STPaperOverflow";
import { Fab } from "@material-ui/core";

export const STWrapper = styled.div`
{
  min-height: 100px;
  padding: 0 10px 0 10px;
  width: 100%;
}
`;

export const CSTPaper = styled(STPaper)`
{
  margin-top: 20px;
  margin-bottom: 20px;
}
`;

export const CSFab = styled(Fab)`
&& {
  transform: scale(0.8);
}
`;

export const STEmptyAdd = styled.div`
{
  margin-top: 20px;
  margin-bottom: 20px;
}
`;

export const STEmptyAddWrapper = styled.div`
&& {
  float: right;
}
`;
